import { CheckCircle2, FileText, FlagTriangleRight, Rocket, TriangleAlert } from "lucide-react";
import type { OvernightItem } from "@/mock";

/** Maps an overnight digest item kind to its quiet glyph. */
export const overnightIcon: Record<OvernightItem["kind"], typeof FileText> = {
  published: Rocket,
  flagged: FlagTriangleRight,
  drafted: FileText,
  won: CheckCircle2,
  alert: TriangleAlert,
};
